export default <string[]>[
  '/forgot-password',
  '/reset-password-success',
  '/reset-password-verify',
  '/reset-password',
  '/region-unavailable',
];
